import { SET_GLOBAL_FILTER } from "../actions/globalFilterActions";

const GlobalFilterInitialState = {};

const globalFilterReducer = (state = GlobalFilterInitialState, action) => {
  switch (action.type) {
    case SET_GLOBAL_FILTER:
      return action.payload;
    default:
      return state;
  }
};

export default globalFilterReducer;
